export const ImageIllustration = () => (
  <svg
    width='400'
    height='300'
    viewBox='0 0 400 300'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='400' height='300' fill='#EDF2F7' />
    <path
      d='M115 55C115 51.6863 117.686 49 121 49H245C248.314 49 251 51.6863 251 55C251 58.3137 248.314 61 245 61H121C117.686 61 115 58.3137 115 55Z'
      fill='#CBD5E0'
    />
    <path
      d='M115 83C115 79.6863 117.686 77 121 77H280C283.314 77 286 79.6863 286 83C286 86.3137 283.314 89 280 89H121C117.686 89 115 86.3137 115 83Z'
      fill='#CBD5E0'
    />
    <path
      d='M123.01 105C118.619 105 115 108.619 115 113.01V187.777C115 192.169 118.619 195.787 123.01 195.787H227.147C231.539 195.787 235.157 192.169 235.157 187.777V113.01C235.157 108.619 231.539 105 227.147 105H123.01ZM123.01 110.34H227.147C228.672 110.34 229.817 111.485 229.817 113.01V176.844L206.412 151.227C205.872 150.654 205.07 150.339 204.284 150.393C203.609 150.43 202.954 150.735 202.49 151.227L183.381 171.504L155.719 140.59C155.129 139.917 154.184 139.575 153.3 139.713C152.712 139.809 152.158 140.107 151.756 140.548L120.339 174.301V113.013C120.339 111.488 121.484 110.343 123.01 110.343L123.01 110.34ZM184.425 123.691C178.558 123.691 173.745 128.504 173.745 134.372C173.745 140.239 178.558 145.053 184.425 145.053C190.293 145.053 195.106 140.239 195.106 134.372C195.106 128.504 190.293 123.691 184.425 123.691Z'
      fill='#718096'
    />
    <path
      d='M115 217.787C115 214.473 117.686 211.787 121 211.787H245C248.314 211.787 251 214.473 251 217.787C251 221.101 248.314 223.787 245 223.787H121C117.686 223.787 115 221.101 115 217.787Z'
      fill='#CBD5E0'
    />
    <path
      d='M115 245.787C115 242.473 117.686 239.787 121 239.787H278C281.314 239.787 284 242.473 284 245.787C284 249.101 281.314 251.787 278 251.787H121C117.686 251.787 115 249.101 115 245.787Z'
      fill='#CBD5E0'
    />
  </svg>
)
